/**
 * descriptionsFonctions.js
 */

import './descriptionsFonctions.scss';
import $ from 'jquery';
import 'tablesorter';

let timer = null;
$(document).ready(function() {
    if($('figure.tableauDescriptionsFonctions').length == 0)
        $("#filtresDescriptionsFonctions").hide();

    $('figure.tableauDescriptionsFonctions table').tablesorter({
        widgets: ['filter'],
        widgetOptions: {
            filter_columnFilters: false,
            filter_ignoreCase: true,
            sortLocaleCompare: true
        }
    });
    $('figure.tableauDescriptionsFonctions table thead th:first-child').addClass("filter-match");
    $("#filtresDescriptionsFonctions :checkbox").change(function() {
        clearTimeout(timer);
        timer = setTimeout(filtrerTableau, 500);
    });
    $("#rechercheDescription").keyup(function() {
        clearTimeout(timer);
        timer = setTimeout(filtrerTableau, 500);
    });
    $("#formFiltres").submit(function() {
        clearTimeout(timer);
        timer = setTimeout(filtrerTableau, 500);
        return false;
    })
    $("#formFiltres label").click(function() {
        $(this).toggleClass("checked");
    })
});

function filtrerTableau() {
    let filtresFinaux = [];
    let filtres = [];
    $("#filtresDescriptionsFonctions :checkbox:checked").each(function() {
        filtres.push($(this).val());
    });
    filtresFinaux[0] = filtres.join("|");

    if($("#rechercheDescription").val() != "")
        filtresFinaux[2] = $("#rechercheDescription").val();

    if(filtresFinaux.length === 1 && filtresFinaux[0] === "")
        $('figure.tableauDescriptionsFonctions table').trigger('filterReset');
    else
        $('figure.tableauDescriptionsFonctions table').trigger('search', [ filtresFinaux ]);
}